// src/components/CroppedMapImage.js
import React, { useEffect } from "react";

// Import coordinate JSONs
import surveyCoords from "../../assets/json/surveyCoords.json";
import surveyCoords1 from "../../assets/json/output1.json";
import sangaliInnerCoord from "../../assets/json/sangaliInner.json";
import sangaliOuterCoord from "../../assets/json/SangliOuter.json";
import kupwadInnerCoord from "../../assets/json/KupwadInner.json";
import kupwadOutterCoord from "../../assets/json/KUPWADOuter.json";
import sangliwadiInnerCoord from "../../assets/json/SangliwadInner.json";

// Import base images
import base1 from "../../assets/image/base1.jpg";

// Map images
import sangaliOuterSM from "../../assets/map/2_Sangli Outer SM 10000_page-0001 (1).jpg";
import sangliwadInnerSm from "../../assets/map/3_Sangliwad Inner-SM 2000_page-0001.jpg";
import kupwadinner3SM from "../../assets/map/6_Kupwad Inner_3-SM 2000_page-0001.jpg";
import kupwadOuterSM from "../../assets/map/7_KUPWAD Outer- SM 10000_page-0001.jpg";
import sangaliInnerSM from "../../assets/map/1_Sangli Inner SM 2000_page-0001.jpg";

const CroppedMapImage = ({ village, survey, onImageReady, key }) => {
  useEffect(() => {
    console.log("=== CroppedMapImage Render Start ===");
    console.log("Props received:", { village, survey });

    // Cleanup function
    let isMounted = true;


    // 1. Wait until data is ready
    if (!village || !survey) {
      console.warn("CroppedMapImage: waiting for village/survey...");
      return () => {
        isMounted = false;
      };
    }
    console.log("Village and Survey available");




    // 2. Choose correct coordinate map based on village
    const surveyCoordMap = {
      "Sangali Inner": sangaliInnerCoord,
      "Sangali Outer": sangaliOuterCoord,
      "Kupwad Inner 1": kupwadInnerCoord,
      "Kupwad Outer": kupwadOutterCoord,
      "Sangliwad Inner": sangliwadiInnerCoord,
    };

    console.log("SurveyCoordMap prepared:", surveyCoordMap);

    const coords = surveyCoordMap[village]?.[survey] ?? null;

    console.log("Coordinates fetched:", coords);

    if (!coords) {
      console.warn(`CroppedMapImage: No coordinates found for ${village} - ${survey}`);
      return;
    }

    // 3. Choose correct image for the selected village
    const villageImageMap = {
      "Sangali Inner": sangaliInnerSM,
      "Sangali Outer": sangaliOuterSM,
      "Kupwad Inner 1": kupwadinner3SM,
      "Kupwad Outer": kupwadOuterSM,
      "Sangliwad Inner": sangliwadInnerSm,
    };

    console.log("VillageImageMap prepared:", villageImageMap);

    const imgSrc = villageImageMap[village] ?? base1;

    console.log("Selected image source:", imgSrc);
    console.log(`Loading image for ${village}...`);

    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = imgSrc;

    console.log("Image object created, src set");



    // 4. On successful image load
    img.onload = () => {
      if (!isMounted) return; // Don't update if component unmounted
      console.log("Image loaded successfully");

      const cropWidth = 600;
      const cropHeight = 500;
      const extraTopSpace = 100;

      const cropX = coords.cropX - cropWidth / 2;
      const cropY = coords.cropY - cropHeight / 2;

      console.log("Crop params:", {
        cropWidth,
        cropHeight,
        cropX,
        cropY,
        extraTopSpace,
      });

      const canvas = document.createElement("canvas");
      canvas.width = cropWidth;
      canvas.height = cropHeight + extraTopSpace;

      console.log("Canvas created", {
        width: canvas.width,
        height: canvas.height,
      });

      const ctx = canvas.getContext("2d");

      console.log("Canvas context obtained");

      // Draw cropped image
      console.log("Drawing cropped image to canvas...");
      ctx.drawImage(
        img,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        extraTopSpace,
        cropWidth,
        cropHeight
      );
      console.log("Image cropped and drawn");

      // Draw arrow
      console.log("Drawing arrow...");
      const centerX = cropWidth / 2;
      const centerY = extraTopSpace + cropHeight / 2;
      const arrowStartY = 30;

      ctx.beginPath();
      ctx.moveTo(centerX, arrowStartY);
      ctx.lineTo(centerX, centerY);
      ctx.strokeStyle = "black";
      ctx.lineWidth = 2;
      ctx.stroke();
      console.log("Arrow line drawn");

      // Arrow head
      console.log("Drawing arrow head...");
      const headLength = 10;
      const angle = Math.atan2(centerY - arrowStartY, 0);
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.lineTo(
        centerX - headLength * Math.cos(Math.PI / 6),
        centerY - headLength * Math.sin(Math.PI / 6)
      );
      ctx.lineTo(
        centerX + headLength * Math.cos(Math.PI / 6),
        centerY - headLength * Math.sin(Math.PI / 6)
      );
      ctx.closePath();
      ctx.fillStyle = "black";
      ctx.fill();
      console.log("Arrow head drawn");

      // Label text
      console.log("Writing label text...");
      ctx.font = "16px Arial";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(`Plot No ${survey}`, centerX, arrowStartY - 10);
      console.log("Label drawn");

      const fullImage = canvas.toDataURL("image/png");
      console.log("Image converted to base64");
      console.log(`CroppedMapImage: Final image ready for ${survey}`);

      if (isMounted) {
        onImageReady(fullImage);
      }

      //onImageReady(fullImage);
      console.log("onImageReady callback fired");
      console.log("=== CroppedMapImage Render Complete ===");
    };

    // 5. Handle image load error
    img.onerror = (err) => {
      if (!isMounted) return;
      console.error("CroppedMapImage: Failed to load image", imgSrc, err);
    };

    return () => {
      isMounted = false;
    };


  }, [village, survey, onImageReady, key]);

  console.log("Component return null");
  return null;
};

export default CroppedMapImage;
